import React from 'react';
import { Box, TextField, InputAdornment, IconButton, Button } from '@mui/material';
import { Search, FilterList, Clear } from '@mui/icons-material';
import PropTypes from 'prop-types';

const PageTopBar = ({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search...',
  onClearSearch,
  showFilter = false,
  onFilterClick,
  filterActive = false,
  buttons = [],
  children,
  sx = {},
}) => {
  return (
    <Box
      className="fade-in"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: 2,
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        minHeight: '56px',
        ...sx,
      }}
    >
      <Box
        className="staggered-animation"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          width: '100%',
        }}
      >
        <TextField
          size="small"
          placeholder={searchPlaceholder}
          value={searchValue || ''}
          onChange={onSearchChange}
          sx={{
            flex: 1,
            '& .MuiOutlinedInput-root': {
              height: '36px',
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: 'text.secondary', fontSize: '20px' }} />
              </InputAdornment>
            ),
            endAdornment: searchValue && (
              <InputAdornment position="end">
                <IconButton size="small" onClick={onClearSearch} sx={{ padding: '4px' }}>
                  <Clear sx={{ fontSize: '16px' }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {showFilter && (
          <IconButton
            onClick={onFilterClick}
            sx={{
              color: filterActive ? 'info.main' : 'text.secondary',
              backgroundColor: filterActive ? '#e3f2fd' : 'transparent',
              '&:hover': {
                backgroundColor: filterActive ? '#bbdefb' : 'action.hover',
              },
            }}
          >
            <FilterList />
          </IconButton>
        )}

        {children}

        {buttons.map((button, index) => (
          <Button
            key={index}
            variant={button.variant || 'contained'}
            color={button.color || 'primary'}
            size="small"
            startIcon={button.icon}
            onClick={button.onClick}
            disabled={button.disabled}
            sx={{
              height: '36px',
              ...button.sx,
            }}
          >
            {button.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

PageTopBar.propTypes = {
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  onClearSearch: PropTypes.func,
  showFilter: PropTypes.bool,
  onFilterClick: PropTypes.func,
  filterActive: PropTypes.bool,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      variant: PropTypes.string,
      color: PropTypes.string,
      icon: PropTypes.node,
      disabled: PropTypes.bool,
      sx: PropTypes.object,
    })
  ),
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default PageTopBar;
